const facilities = [
  {
    id: "tampa-hillsborough-clerk",
    name: "Hillsborough County Clerk of Court",
    type: "Clerk Passport Acceptance",
    address: "800 E Twiggs St",
    city: "Tampa",
    state: "FL",
    zip: "33602",
    phone: "813-276-8100",
    hours: "Mon–Fri 8am–4:30pm",
    distance: "Downtown Tampa",
    website: "https://www.hillsclerk.com/",
    websiteLabel: "Hillsborough Clerk",
    notes: "County clerk acceptance option. Call ahead for appointments, hours, and passport service availability.",
    icon: "ri-government-line",
  },
  {
    id: "tampa-usps-downtown",
    name: "USPS Downtown Tampa",
    type: "USPS Passport Acceptance",
    address: "500 Zack St",
    city: "Tampa",
    state: "FL",
    zip: "33602",
    phone: "800-275-8777",
    hours: "Mon–Fri 9am–5pm",
    distance: "Downtown Tampa",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "USPS Appointment Scheduler",
    notes: "USPS acceptance facility. Confirm photo services when booking.",
    icon: "ri-mail-line",
  },
  {
    id: "tampa-usps-carrollwood",
    name: "USPS Carrollwood Branch",
    type: "USPS Passport Acceptance",
    address: "4100 W Linebaugh Ave",
    city: "Tampa",
    state: "FL",
    zip: "33624",
    phone: "800-275-8777",
    hours: "Mon–Fri 9am–5pm, Sat 9am–12pm",
    distance: "North Tampa (~8.4 mi)",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "USPS Appointment Scheduler",
    notes: "North Tampa option. Book online and call ahead to confirm passport acceptance.",
    icon: "ri-mail-line",
  },
  {
    id: "tampa-usps-westshore",
    name: "USPS Westshore Branch",
    type: "USPS Passport Acceptance",
    address: "4004 W Kennedy Blvd",
    city: "Tampa",
    state: "FL",
    zip: "33609",
    phone: "800-275-8777",
    hours: "Mon–Fri 9am–5pm",
    distance: "West Tampa (~5.2 mi)",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "USPS Appointment Scheduler",
    notes: "West Tampa option. Book online and call ahead to confirm passport acceptance.",
    icon: "ri-mail-line",
  },
  {
    id: "tampa-usps-hyde-park",
    name: "USPS Hyde Park Branch",
    type: "USPS Passport Acceptance",
    address: "609 S Howard Ave",
    city: "Tampa",
    state: "FL",
    zip: "33606",
    phone: "800-275-8777",
    hours: "Mon–Fri 9am–5pm",
    distance: "Hyde Park (~2.1 mi)",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "USPS Appointment Scheduler",
    notes: "South Tampa option. Call ahead to confirm passport acceptance availability before visiting.",
    icon: "ri-mail-line",
  },
  {
    id: "tampa-usps-temple-terrace",
    name: "USPS Temple Terrace Branch",
    type: "USPS Passport Acceptance",
    address: "8225 N 56th St",
    city: "Temple Terrace",
    state: "FL",
    zip: "33617",
    phone: "800-275-8777",
    hours: "Mon–Fri 9am–5pm",
    distance: "Temple Terrace (~7.1 mi)",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "USPS Appointment Scheduler",
    notes: "Northeast Tampa option. Confirm appointment requirements and photo availability.",
    icon: "ri-mail-line",
  },
  {
    id: "tampa-usps-downtown-2",
    name: "USPS Downtown Tampa — Channelside",
    type: "USPS Passport Acceptance",
    address: "1201 E Twiggs St",
    city: "Tampa",
    state: "FL",
    zip: "33602",
    phone: "800-275-8777",
    hours: "Mon–Fri 9am–5pm",
    distance: "Channelside (~1.2 mi)",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "USPS Appointment Scheduler",
    notes: "Downtown Tampa option. Call ahead to confirm passport acceptance.",
    icon: "ri-mail-line",
  },
];

export default function TampaAcceptanceFacilitiesSection() {
  return (
    <section id="acceptance-facilities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Passport Acceptance Clerks
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Facilities Near Tampa
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-6">
            First-time applicants — and most applicants who are not eligible for a standard mail-in renewal or a second passport — must apply in person at a passport acceptance clerk, and all locations require an appointment. This is the self-service option, typically chosen by those on a tighter budget who have at least 1–2+ months before travel and don&apos;t mind the slower, standard processing times.
          </p>
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-5 max-w-2xl mx-auto text-left">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-amber-100 flex-shrink-0 mt-0.5">
                <i className="ri-error-warning-line text-amber-600 text-base"></i>
              </div>
              <p className="text-gray-700 text-sm leading-relaxed">
                If you want to use a registered U.S. Department of State courier to receive your passport in as little as 3 days, you must sign up with{" "}
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="font-bold text-[#1A365D] underline underline-offset-2 hover:text-[#F6C344] transition-colors"
                >
                  Fast Passport Center
                </a>{" "}
                <strong>before</strong> going to the clerk. Once you apply at the clerk, your documents are sent through the standard route, and we cannot intervene or upgrade it to an expedited courier service afterward.
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          {facilities.map((f) => (
            <article
              key={f.id}
              className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 flex flex-col hover:border-[#F6C344] transition-all duration-200"
            >
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`${f.icon} text-[#F6C344] text-base`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-bold text-[#1A365D] text-sm leading-snug mb-0.5">{f.name}</h3>
                  <span className="text-xs text-gray-400 font-medium">{f.type}</span>
                </div>
              </div>

              <div className="space-y-2 flex-1">
                <div className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-map-pin-line text-[#F6C344] flex-shrink-0 mt-0.5 text-base"></i>
                  <span>
                    {f.address}, {f.city}, {f.state} {f.zip}
                  </span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <i className="ri-phone-line text-[#F6C344] flex-shrink-0 text-base"></i>
                  <a href={`tel:${f.phone.replace(/-/g, "")}`} className="hover:text-[#1A365D] transition-colors">
                    {f.phone}
                  </a>
                </div>
                <div className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-time-line text-[#F6C344] flex-shrink-0 mt-0.5 text-base"></i>
                  <span>{f.hours}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <i className="ri-road-map-line text-[#F6C344] flex-shrink-0 text-base"></i>
                  <span>{f.distance}</span>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  <i className="ri-global-line text-[#F6C344] flex-shrink-0 text-base"></i>
                  <a
                    href={f.website}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-[#1A365D] font-medium hover:text-[#F6C344] transition-colors underline underline-offset-2"
                  >
                    {f.websiteLabel}
                  </a>
                </div>
              </div>

              <div className="mt-4 pt-4 border-t border-gray-200">
                <div className="flex items-start gap-2 mb-3">
                  <span className="inline-flex items-center gap-1 text-xs font-semibold bg-amber-50 text-amber-700 px-2 py-0.5 rounded-full whitespace-nowrap">
                    <i className="ri-calendar-line text-xs"></i> Appointment Required
                  </span>
                </div>
                <p className="text-xs text-gray-400 leading-relaxed italic">{f.notes}</p>
              </div>
            </article>
          ))}
        </div>

        {/* CTA callout */}
        <div className="bg-[#1A365D] rounded-lg p-4 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-start gap-4">
            <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
              <i className="ri-information-line text-[#1A365D] text-xl"></i>
            </div>
            <div>
              <p className="font-bold text-white text-base mb-1">
                Last chance — sign up now, before your clerk visit
              </p>
              <p className="text-white/70 text-sm leading-relaxed max-w-xl">
                If you need your passport fast, sign up with Fast Passport Center <strong className="text-white">before</strong> you walk into that clerk appointment. Once your documents go through the standard route, they&apos;re gone — there&apos;s no pulling them back, no upgrading, no saving you after the fact. Don&apos;t wait and hope it works out.
              </p>
            </div>
          </div>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0"
          >
            Start My Passport <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}